import { Component, Input } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { tap } from "rxjs/operators";
import { ICameraCommand } from "../../../_models/ICameraCommand";
import { CameraCommandType } from "../../../_models/IPulseRecord";
import { PulseService } from "../pulse.service";
import './pulse-response.component.scss';

@UntilDestroy()
@Component({
    selector: 'pulse-response',
    template: require('./pulse-response.component.html')
})
export class PulseResponseComponent {
    @Input() pulseResponseJson: string;
    pulseResponse: ICameraCommand;

    CameraCommandType = CameraCommandType;

    constructor(
        private readonly pulseService: PulseService) { }

    ngOnInit(): void {
        this.pulseResponse = JSON.parse(this.pulseResponseJson) as ICameraCommand;
        console.log(this.pulseResponse)
    }
}
